// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1TMWw","overflowing":"ReadFullNote_overflowing__28nB7"};